import { produce } from "immer";
import * as Actions from "pages/Quarantine/store/quarantineActions";
import * as quarantinesActions from "pages/Quarantine/store/quarantinesActions";

const initialState = {
  currentId: null,
  queueIdFromQueryString: null,
  isDetailsOpen: false,
  isReleaseOpen: false,
  isAddToWListOpen: false,
  isDeleteOpen: false,
  errorMessage: null,
  isLoading: false,
  searchParams: null,
  totalCount: 0,
  currentPage: 1,
  isResultOpen: false,
  removeResult: [],
  releasedIds: [],
  releasedSenders: [],
  isSenderQuarantinesOpen: false,
  senderQuarantines: null
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.OPEN_DETAILS:
      const { id } = action.payload;

      draft.isDetailsOpen = true;
      draft.currentId = id;
      break;

    case Actions.CLOSE_DETAILS:
      draft.isDetailsOpen = false;
      draft.currentId = null;
      break;

    case Actions.OPEN_RELEASE:
      const { queueIdFromQueryString } = action.payload;
      draft.isReleaseOpen = true;
      draft.queueIdFromQueryString = queueIdFromQueryString;
      break;

    case Actions.CLOSE_RELEASE:
      draft.isReleaseOpen = false;
      draft.errorMessage = null;
      draft.queueIdFromQueryString = null;
      break;

    case Actions.RELEASE_QUARANTINE:
      draft.isLoading = true;
      draft.errorMessage = null;
      draft.removeResult = [];
      draft.releasedIds = [];
      draft.releasedSenders = [];
      break;

    case Actions.RELEASE_QUARANTINE_SUCCESS:
      draft.isLoading = false;
      draft.isReleaseOpen = false;
      draft.errorMessage = null;
      draft.queueIdFromQueryString = null;
      draft.removeResult = action.payload.removeResult;
      draft.releasedIds = action.payload.releasedIds || [];
      draft.releasedSenders = action.payload.releasedSenders || [];
      break;

    case Actions.RELEASE_QUARANTINE_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.OPEN_ADD_TO_WLIST:
      draft.isAddToWListOpen = true;
      break;

    case Actions.CLOSE_ADD_TO_WLIST:
      draft.isAddToWListOpen = false;
      draft.errorMessage = null;
      break;

    case Actions.ADD_TO_WLIST:
      draft.isLoading = true;
      draft.errorMessage = null;
      break;

    case Actions.ADD_TO_WLIST_SUCCESS:
      draft.isLoading = false;
      draft.isAddToWListOpen = false;
      draft.errorMessage = null;
      break;

    case Actions.ADD_TO_WLIST_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case Actions.OPEN_DELETE:
      draft.isDeleteOpen = true;
      break;

    case Actions.CLOSE_DELETE:
      draft.isDeleteOpen = false;
      draft.errorMessage = null;
      break;

    case Actions.DELETE_QUARANTINE:
      draft.isLoading = true;
      draft.errorMessage = null;
      draft.removeResult = [];
      draft.releasedIds = [];
      draft.releasedSenders = [];
      break;

    case Actions.DELETE_QUARANTINE_SUCCESS:
      draft.isLoading = false;
      draft.isDeleteOpen = false;
      draft.errorMessage = null;
      draft.removeResult = action.payload.removeResult;
      break;

    case Actions.DELETE_QUARANTINE_FAILED:
      draft.isLoading = false;
      draft.errorMessage = action.payload.errorMessage;
      break;

    case quarantinesActions.FETCH_QUARANTINES_SUCCESS:
      const payload = action.payload;
      draft.totalCount = payload.totalCount;
      break;

    case Actions.OPEN_RESULT:
      draft.isResultOpen = true;
      break;

    case Actions.CLOSE_RESULT:
      draft.isResultOpen = false;
      break;

    case Actions.OPEN_SENDER_QUARANTINES:
      draft.isSenderQuarantinesOpen = true;
      draft.senderQuarantines = {
        sender: action.payload.sender,
        count: action.payload.count
      };
      break;

    case Actions.CLOSE_SENDER_QUARANTINES:
      draft.isSenderQuarantinesOpen = false;
      draft.senderQuarantines = null;
      draft.releasedIds = [];
      draft.releasedSenders = [];
      break;

    case Actions.SET_SEARCH_PARAMS:
      draft.searchParams = action.payload.searchParams;
      break;

    case Actions.SET_PAGE:
      draft.currentPage = action.payload.page;
      break;

    default:
      break;
  }
}, initialState);

export default reducer;
